<div class="dialog-container">
    <h2 mat-dialog-title style="font-family: OpenSansLight;"> Reinstate Account? </h2>
    <hr>
    <mat-dialog-content>
        <p>Are you sure you want to reinstate {{data.name}}'s account?</p>
        <br>
        <p>This member will be sent an invite, and will be able to access any previously created scenarios.</p>
        <br>
        <!-- <section>
            <mat-checkbox [(ngModel)]="checked" style="font-size: medium; color: black;">I understand this member will be archived</mat-checkbox>
        </section> -->
    </mat-dialog-content>
    <br>
    <mat-dialog-actions>
        <div class="buttons">
            <span>
                <button mat-button color="primary" mat-dialog-close>Cancel</button>
                <button mat-raised-button mat-dialog-close
                    [mat-dialog-close]="true" 
                    class="green-button">Reinstate Account</button>
            </span>
        </div>
    </mat-dialog-actions>
</div>